import { EntityMetadataMap } from '@ngrx/data';

const entityMetadata: EntityMetadataMap = {
    Alert: {
        selectId: (res) => res['source_id'],
    },
    Event: {
        selectId: (res) => res['id'],
    },
    Baseline: {
        selectId: (res) => res['id'],
    },
    Category: {
        selectId: (res) => res['name'],
    },
    Deviation: {
        selectId: (res) => res['id'],
    },
    User: {
        selectId: (res) => res['id'],
    },
    BaselineCurrentPostureCount: {
        selectId: (res) => res['tenant_count'],
    },
    TicketCount: {
        selectId: (res) => res['psa'],
    },
};

// Optional
export const pluralNames = { Category: 'Categories', Deviation: 'Deviations' };

export const entityConfig = {
    entityMetadata,
    pluralNames,
};
